module.exports = __webpack_public_path__ + "img/e00ae20.png";